import React, { useMemo, useState } from "react";
import {
  AlertComponent,
  BreadcrumbComponent,
} from "../../../common/components";
import { routes } from "../../../constants/routes";
import "./create-new-template.scss";
import PreviewTemplatesList from "../preview-templates-list";
import NewEmailTemplateEditor from "./new-email-template-editor/new-email-template-editor";
import { AddNewEmailTemplateProps } from "../email-letter-types";
import { useSetLoading } from "../../../common/hooks/appearance";
import { Box } from "@mui/material";
import GridOnIcon from '@mui/icons-material/GridOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

interface toggleEditor {
  isOpen: boolean;
  mode: "view" | "edit" | "new";
  template: any;
}
const AddNewEmailTemplate: React.FC<AddNewEmailTemplateProps> = ({
  isShowCreateTemplate,
  setShowCreateTemplateOpen,
  addNewTemplateBreadcrumb=[],
}) => {
  const [toggleEditor, setToggleEditor] = useState<toggleEditor>({
    isOpen: false,
    mode: "view",
    template: null,
  });
  const [alertMessage, setAlertMessage] = useState<any>({
    open: false,
    message: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState<string>("updated_at");
  const [gridSize,setGridSize] = useState<number>(3);

  const handleOnCloseEditor = () => {
    setToggleEditor({
      isOpen: false,
      mode: "view",
      template: null,
    });
  };

  const handleOnClickTemplate = (template: any) => {
    console.log("template->", template);
    setToggleEditor({
      isOpen: true,
      mode: "new",
      template: template,
    });
  };

  const theme = useTheme();
  //for xs devices it will be true
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <div className="leadlist-wrapper add-new-template-wrapper">
      <div className="breadcrumb-wrapper">
        <BreadcrumbComponent breadcrumbLink={addNewTemplateBreadcrumb} />
      </div>
      {toggleEditor?.isOpen ? (
        <>
          <NewEmailTemplateEditor
            onClose={handleOnCloseEditor}
            setAlertMessage={setAlertMessage}
            toggleEditor={toggleEditor}
            setToggleEditor={setToggleEditor}
            setIsLoading={setIsLoading}
          />
        </>
      ) : (
        <>
          <div className="add-new-template-header-body-wrapper">
            <div className="add-new-template-header-wrapper">
              <div className="header-text">
                Start by Selecting a Sample Below
              </div>
              <div className="header-right-side-wrapper">
                <div className="custom-btn-wrapper">
                  <button
                    className="custom-btn create-rule-btn"
                    onClick={() =>
                      setToggleEditor({
                        isOpen: true,
                        mode: "new",
                        template: null,
                      })
                    }
                  >
                    New Template (Blank)
                  </button>
                </div>
                <div className="icons-wrapper">
                  <Box className="sort-wrapper">
                    Sort
                    <div
                      onClick={() => {
                        setSortBy('name')
                        }}
                        className="icon-div"
                        title="Alphabetically"
                      >
                        <i className="fa fa-sort-alpha-asc" aria-hidden="true" style={{
                          color:`${sortBy !== 'name' ? 'gray' : '#000'}`,
                        }}></i>
                      </div>
                    <div
                      onClick={() => {
                        setSortBy('updated_at')
                      }}
                      className={`icon-div calendar-icon-div ${sortBy !== 'updated_at' ? "not-active-sort-icon" : ""}`}
                      title="Newest to Oldest"
                    ><CalendarMonthIcon className="calendar-icon"/></div>
                  </Box>
                    {!isMobile && <Box className="size-wrapper">
                      Size
                      <div
                        onClick={() => {
                          setGridSize(2);
                        }}
                        className={`icon-div ${gridSize !== 2 ? "not-active-grid" : ""}`}
                      ><GridOnIcon fontSize="small" className="small-grid-icon" /></div>
                      <div
                        onClick={() => {
                          setGridSize(3);
                        }}
                        className={`icon-div ${gridSize !== 3 ? "not-active-grid" : ""}`}
                      ><GridOnIcon /></div>
                    </Box>}
                </div>
              </div>
            </div>
            <PreviewTemplatesList
                handleOnClickTemplate={handleOnClickTemplate}
                sortBy={sortBy}
                gridSize={gridSize}
            />
          </div>
        </>
      )}

      {alertMessage?.open && (
        <AlertComponent
          message={alertMessage?.message}
          type={alertMessage?.type || "error"}
          open={alertMessage?.open}
          onClose={() => {
            setAlertMessage({ open: false });
          }}
        />
      )}
    </div>
  );
};

export default AddNewEmailTemplate;
